<script>
    import Spinner from 'vue-simple-spinner';
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            source: String,
            sourceCourses: String
        },
        components: {Spinner},
        data() {
            return {
                form: new Form({
                    municipality: ''
                })
            }
        },
        watch: {
            'form.municipality': {
                handler(val) {
                    this.onSubmit()
                }
            }
        },
        mounted() {
            let vm = this

            this.initSelect()

            $("#giftMunicipalityModal").on('hidden.bs.modal', function(e) {
                $(vm.$refs.municipality).val('').trigger('change')
            })
        },
        methods: {
            initSelect() {
                let vm = this
                $(this.$refs.municipality).select2({
                    placeholder: 'Città',
                    width: '100%',
                    ajax: {
                        url: vm.source,
                        processResults({municipalities}) {
                            let results = []
                            municipalities.forEach(i => {
                                results.push({
                                    id: i.name,
                                    text: i.name
                                })
                            })

                            return {
                                results: results
                            }
                        }
                    }
                });

                $(this.$refs.municipality).on('change', function(e) {
                    vm.$set(vm.form, 'municipality', $(this).val())
                })
            },
            onClose() {
                $("#giftMunicipalityModal").modal('hide')
            },
            onSubmit() {
                this.form
                    .get(this.sourceCourses, {}, true)
                    .then(({courses}) => {
                        this.$emit('update', {
                            courses,
                            params: this.form.data()
                        })
                        $("#giftMunicipalityModal").modal('hide')
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/gift/GiftSearchMunicipalityForm.vue